import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar'; 
import styles from './../../Assets/CSS/Style.module.css';
import { BiSolidPhoneCall } from 'react-icons/bi'; 
import { MdEmail } from 'react-icons/md'; 
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify'; 
import Info from './Info';
 
function ContactUs() { 
    const [isLoading, setIsLoading] = useState(false);  
    const [setting, setSetting] = useState([]);
    useEffect(() => {  
        document.title = 'Infomart | Agent Contact Us';   
        setIsLoading(true);  
        axios.get(`${BASE_URL}/setting`, { 
            headers: { 
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setSetting(res.data.data);
            setIsLoading(false); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
            setIsLoading(false);
        });        
    }, []);  
    return (
        <div className="app">
            <div className="outlet"> 
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    :
                        <div className={styles.contactUsPageContainer}>
                            <h4>Contact Us</h4>
                            <div className={styles.contactUsMain}>
                                <div className={styles.contactUsLeft}>
                                    <h5 className="mt-4">Our Address: </h5>
                                    <div className="text-muted">{setting.address}</div>
                                    <h5 className="mt-4">Phone:</h5>
                                    <div className="text-muted"><span><BiSolidPhoneCall /></span> +91 {setting.p_phone}</div> 
                                    <h5 className="mt-4">Email: </h5>
                                    <div className="text-muted"><span><MdEmail /></span> {setting.email}</div>
                                </div>  
                            </div>
                        </div> 
                    } 
                </div>
            </div> 
        </div>
    );
}

export default ContactUs;     